"use client";

import { useEffect, useState } from "react";
import { useRouter, usePathname } from "next/navigation";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthGuard({ children }: { children: React.ReactNode }) {
  const { token, user } = useAuth(); // Removido 'loading', pois não existe no seu tipo
  const router = useRouter();
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    // Só agimos após o componente estar montado no cliente
    if (mounted) {
      const publicRoutes = ["/", "/login", "/register"];
      const isPublicRoute = publicRoutes.includes(pathname);

      // Se não houver token e a rota for privada (como /empresas) -> Login
      if (!token && !isPublicRoute) {
        router.push("/login");
      }
      
      // Se houver token e o usuário tentar acessar a Landing, Login ou Register -> Dashboard
      // Adicionamos a verificação de 'user' para garantir que o perfil foi carregado
      if (token && user && isPublicRoute) {
        router.push("/dashboard");
      }
    }
  }, [token, user, pathname, router, mounted]);

  // Enquanto o componente não monta, evitamos renderizar para prevenir erro de Hydration
  if (!mounted) {
    return null;
  }

  // Renderiza os filhos (Landing Page ou Dashboard)
  return <>{children}</>;
}